var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-page",
    { staticClass: "stretch-grid" },
    [
      _c("Grid", {
        staticClass: "fit",
        attrs: {
          module: _vm.module,
          data: _vm.courseList,
          columns: _vm.columnOptions,
          onLaunch: _vm.select,
          loading: _vm.loadingData,
          onRequest: _vm.fetch,
          filterable: _vm.filterable
        },
        scopedSlots: _vm._u([
          {
            key: "header-item",
            fn: function(props) {
              return [_vm._v("\n      " + _vm._s(props.label) + "\n    ")]
            }
          },
          {
            key: "col-item",
            fn: function(props) {
              return [_vm._v("\n      " + _vm._s(props.value) + "\n    ")]
            }
          }
        ])
      }),
      _vm.open
        ? _c(
            "DetailsModal",
            { attrs: { module: _vm.module } },
            [
              _c(
                "template",
                { slot: "header-options" },
                [
                  _vm.$p(["ADMIN"])
                    ? _c(
                        "q-btn-dropdown",
                        { attrs: { icon: "more vert" } },
                        [
                          _c(
                            "q-list",
                            { attrs: { link: "" } },
                            [
                              _c(
                                "q-item",
                                {
                                  directives: [
                                    {
                                      name: "close-overlay",
                                      rawName: "v-close-overlay"
                                    }
                                  ],
                                  nativeOn: {
                                    click: function($event) {
                                      _vm.onRemove()
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "q-item-main",
                                    [
                                      _c(
                                        "q-item-tile",
                                        { attrs: { label: "" } },
                                        [
                                          _c("q-icon", {
                                            attrs: {
                                              name: "fa fa-trash",
                                              color: "red"
                                            }
                                          }),
                                          _vm._v(" Delete Course")
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            2
          )
        : _vm._e(),
      _c(
        "q-layout-footer",
        [
          _c(
            "q-toolbar",
            [
              _c("q-toolbar-title"),
              _c("q-btn", {
                attrs: { label: "New Course", icon: "add", color: "primary" },
                on: {
                  click: function($event) {
                    _vm.addNew()
                  }
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }